module.exports = __webpack_public_path__ + "840583b4ef899bae206f5cd6e9e6ad1e.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/components/sp-directory-label/sp-directory-label.html
// module id = 997
// module chunks = 0